import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"

import { Typography } from "@material-ui/core"

// import app components
import FlexibleContent from "../../components/_flexibleContent"
import Textarea from "../../components/textarea"

import Hero from "../../components/hero"
import SideBar from "../../components/SideBar"
import Edges from "../../components/_layout/edges"

import { Content, PageWrapper } from "../../container/layout/Layout"

export default function product({ data }) {
  const {
    wordsbyCollections: {
      post_title,
      post_content,
      acf: { content_collection, ...heroFields },
      pathname,
      featured_img
    }
  } = data

  return (
    <>
      <Hero
        {...heroFields}
        autoPlay
        interval={10000}
        post_title={post_title}
        path={pathname}
        featuredImage={featured_img}
      />

      <Edges size="lg">
        <Content id="read-more">
          <SideBar />
          <PageWrapper>
            {heroFields?.hero_size !== "large" && post_title && (
              <>
                <Typography variant="h1">
                  {post_title.startsWith("Western Red Cedar") ? (
                    <>
                      Western Red Cedar
                      <br />
                      {post_title.replace("Western Red Cedar ", "")}
                    </>
                  ) : (
                    post_title
                  )}
                </Typography>
              </>
            )}
            {!!post_content && <Textarea content={post_content} />}
            {!!content_collection && (
              <FlexibleContent
                rows={content_collection}
                data={{
                  post_title,
                  pathname
                }}
              />
            )}
          </PageWrapper>
        </Content>
      </Edges>
    </>
  )
}

export const CollectionQuery = graphql`
  query ProductSinglePost($id: Int!) {
    wordsbyCollections(ID: { eq: $id }) {
      pathname
      post_title
      post_content
      featured_img {
        childImageSharp {
          fluid(maxWidth: 2560, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      acf {
        ...heroContent
        content_collection {
          ...flexibleContent
        }
      }
    }
  }
`
